<div class="d-flex flex-column w-100 position-relative" [ngClass]="{'section-title-2-spacer': addSpacer}">
  <div class="section-title-2-border bg-{{color}}" *ngIf="hasBorder"></div>
  <h2 class="elsa-title-font text-{{color}} text-uppercase section-title-2-title">{{title}}</h2>
</div>
